import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cep'
})
export class CepPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value != null){
      value = value.toString();
      return value.slice(0,5) + '-' + value.slice(5,8);
    }
    else{
      return value;
    }
  }

}
